/**
 * Append query string to the links with class 'append-price-params',
 * those query strings are coming from pricing page buy now button
 */
document.querySelectorAll('.append-price-params').forEach(e => {
    const objUrlParams = new URLSearchParams(window.location.search);
    const plan = objUrlParams.get('plan');
    const sheep = objUrlParams.get('sheep');
    const cattle = objUrlParams.get('cattle');

    if ( plan && sheep && cattle ) {
        e.href = e.href + '/' + plan + '?sheep=' + sheep + '&cattle=' + cattle;
    } else {
      // redirect to pricing page if not admin
        if ( ! document.body.classList.contains('logged-in')) {
            window.location.href = "/pricing";
        }
    }
})
